import React from 'react';

export type SwitchingContextProps = {
  context: CMx.Context;
  changingContext: boolean;
};

export const SwitchingContext = ({
  context,
  changingContext
}: SwitchingContextProps) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  };

  const iframeUrl = `/context.html?organizationName=${encodeURIComponent(
    context.activeContext?.organizationName || ''
  )}&changingContext=${changingContext}`;

  return (
    <>
      <div style={containerStyle}>
        <iframe
          src={iframeUrl}
          style={{
            width: '100%',
            height: '100%',
            border: 'none'
          }}
          title="Context Switching"
        />
      </div>
    </>
  );
};
